
import Vue from "vue";
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { IDataTableColumn } from "winfakt-vue-components";
import {Script} from "@/models/script";
import {ScriptService} from "@/services/script-service";

export default Vue.extend({
	data(){
		return {
			scripts: [] as Script[],
			selectedRows: [] as Script[]
		};
	},
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		},
		value: {
			type: Object as ()=>Dossier,
			required: true
		},
	},
	computed: {
		columns():IDataTableColumn[]{
			return [
				{
					name: "ID",
					property: "ID",
					width: "40px",
				},
				{
					name: "Name",
					property: "Name",
					width: "200px"
				},
				{
					name: "Created by",
					property: "CreateddBy",
					width: "200px"
				},
				{
					name: "Edited by",
					property: "LastEditedBy",
					width: "200px"
				}
			];
		},
		notAllowedToView():boolean {
			if (this.selectedRows.length == 1) {
				return false;
			}
			return true;
		}
	},
	methods: {
		async fetch(){
			this.scripts = await ScriptService.getScripts(this.value.id);
		},
		showScriptInfo(){
			this.$router.push(`/companies/${this.company.id}/dossier/${this.value.id}/scripts/info/${this.selectedRows[0].ID}`);
		},
		compare(s1:Script, s2:Script):boolean{
			return s1.ID == s2.ID;
		}
	},
	mounted(){
		this.fetch();
	}
});
